import React from 'react';

const Icon = ({ type, size = 18, color = "currentColor", strokeWidth = 2 }) => {
    const svgProps = {
        width: size, height: size,
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: color,
        strokeWidth,
        strokeLinecap: "round",
        strokeLinejoin: "round",
    };
    const icons = {
        check:    <svg {...svgProps}><polyline points="20 6 9 17 4 12"/></svg>,
        x:        <svg {...svgProps}><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
        chevron:  <svg {...svgProps}><polyline points="9 18 15 12 9 6"/></svg>,
        payments: <svg {...svgProps}><rect x="1" y="4" width="22" height="16" rx="2"/><path d="M1 10h22"/></svg>,
        account:  <svg {...svgProps}><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>,
        help:     <svg {...svgProps}><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 015.83 1c0 2-3 3-3 3"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>,
    };
    return <span style={{ width: size, height: size, display: 'inline-flex' }}>{icons[type] || null}</span>;
};

export default Icon;
